<script>
export default {
  methods: {
    //修改语言
    changeLang(value) {
      this.$i18n.$locale(value)
    }
  }
}
</script>

<template>
  <!--多语言-->
  <el-dropdown placement="bottom" @command="changeLang">
    <!--当前选中语言-->
    <span class="language">
      {{ $store.state.language[$i18n.locale] }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>

    <!--下拉语言-->
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in $i18n.availableLocales" :key="item" :command="item" :class="[$i18n.locale === item ? 'acitve' : '']">
        {{ $store.state.language[item] }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style scoped lang="scss">
.language{
  cursor: pointer;
}
</style>